// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Search, StarOutlineSharp, WarningAmber } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Badge,
  Box,
  Button,
  Card,
  Chip,
  Dialog,
  Divider,
  FormControlLabel,
  Grid,
  Icon,
  InputAdornment,
  List,
  ListItem,
  MenuItem,
  Stack,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useTheme,
  useMediaQuery,
  IconButton,
} from '@mui/material';

// import noIncidentImg from 'src/assets/images/placeholders/drawing-checklist.png';
import noIncidentImg from 'src/assets/images/placeholders/broken-package.webp';
import { IconBugFilled, IconChevronDown, IconEye, IconFilter, IconInfoCircle, IconSettings, IconShieldLock, IconSubtask, IconWorld, IconWorldWww, IconX, IconZoomIn } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { HiOutlineCursorClick } from 'react-icons/hi';
import { TbFileExport } from 'react-icons/tb';
import { useSelector } from 'react-redux';
import { fetchSingleApi } from 'src/App';
// import NoFindingsSelectedImage from 'src/assets/images/svgs/app-info.svg';
import NoFindingsSelectedImage from 'src/assets/images/gif/app-info.gif';
import PageContainer from 'src/components/container/PageContainer';
import NoDomainAddedInfoCard from 'src/components/shared/NoDomainAddedInfoCard';
import { setBreadcrumb, setPersist } from 'src/store/my_pages/app';
import { AppState, dispatch } from 'src/store/Store';
import { exportToExcel } from 'src/utils/utils';
import { apiConfig, getApiUrl } from 'src/config/apiConfig';
import axiosIn from 'src/middlewares/axiosInterceptor';
import { minHeight } from '@mui/system';

const OverviewPage_init = () => {
  const sum_Rx = useSelector((state: AppState) => state.summaryReducer);
  const { persist } = useSelector((state: AppState) => state.appGeneralReducer);

  const [statusData, setStatusData] = useState<any>({});
  const [statisticsData, setStatisticsData] = useState<any>({});

  const [tabId, setTabId] = React.useState(0);
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabId(newValue);
  };
  const [searchValue, setSearchValue] = useState('');

  // useEffect(() => {
  //   if (persist.userJobScheduleId) {
  //   }
  // }, [persist.userJobScheduleId]);

  useEffect(() => {
    const BCrumb = [
      {
        to: '/',
        title: 'Home',
      },
      {
        title: 'Overview',
      },
    ];
    dispatch(setBreadcrumb(BCrumb));
  }, []);

  useEffect(() => {
    const fetch_issues_findings = async (websiteVulnerabilityId: string) => {
      try {
        const findingsRes: any = await axiosIn.get(getApiUrl(apiConfig.issues_findings, { websiteVulnerabilityId }));
        await dispatch(setPersist({ key: 'issues_findings', value: findingsRes?.data || [] }));
      } catch (error) {}
    };
    if (persist.userJobScheduleId) {
      const websiteVulnerabilityId = persist.schedule_scan?.find((i: any) => i.id === persist.userJobScheduleId)?.status?.websiteVulnerabilityId;
      if (websiteVulnerabilityId) {
        fetch_issues_findings(websiteVulnerabilityId);
      }
      // TODO TEST
      fetchSingleApi('report_wafs');
    }
  }, [persist.userJobScheduleId, persist.schedule_scan]);

  useEffect(() => {
    // setStatusData(persist.activeDomainStatus);
    // setStatisticsData(persist.scanStatistics);
  }, [persist.activeDomainStatus]);

  if (!persist?.userJobScheduleId && !persist?.is_initial_fetches_loading) {
    return <NoDomainAddedInfoCard />;
  }

  return (
    <PageContainer title="Overview" description="This is overview page">
      <Box>
        <Box sx={{ marginY: 1 }} />
        <Grid container spacing={3}>
          {/* sx={{ '&>.MuiGrid-root': { p: 0.5, mt: 2 } }} */}
          <UnitedTables persist={persist} />
        </Grid>
      </Box>
    </PageContainer>
  );
};

export default OverviewPage_init;

type Accordion_Contents_Type = {
  title: string;
  info_tooltip_text?: string | JSX.Element;
  icon: JSX.Element;
  content: JSX.Element;
};
const filterFields = [
  { key: 'category', label: 'Category' },
  { key: 'severity', label: 'Severity' },
  { key: 'confidence', label: 'Confidence' },
  { key: 'status', label: 'Status' },
  { key: 'locationUrl', label: 'Location' },
  // Add more fields as needed
];
const UnitedTables = ({ persist }: any) => {
  const [devToggle, setdevToggle] = useState(false);
  const [tabId, setTabId] = React.useState(0);
  const [selectedFinding, setSelectedFinding] = React.useState<any>(null);
  const [filteredFindings, setFilteredFindings] = useState(persist?.issues_findings || []);
  const [filters, setFilters] = useState<any>({});
  const [searchValue, setSearchValue] = useState('');

  // Device size detection
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileDialogOpen, setMobileDialogOpen] = useState(false);

  // const flattedFindings = Object.entries(mockResponse).flatMap(([key, array]: any) =>
  //   array.map((item) => ({
  //     ...item,
  //     keyname: key,
  //   })),
  // );

  useEffect(() => {
    //? Set the findings when arrived
    const _theFindings = persist?.issues_findings?.map((item: any, index: number) => ({
      ...item,
      findingId: index,
    }));
    setFilteredFindings(_theFindings);
  }, [persist.issues_findings]);

  useEffect(() => {
    //? Open the first finding by default
    !isMobile && filteredFindings?.length > 0 && setSelectedFinding(filteredFindings[0]);
  }, [filteredFindings]);

  // Utility function for deep search
  function deepSearch(obj: any, search: string): boolean {
    if (!search) return true;
    if (obj == null) return false;
    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean') {
      return obj.toString().toLowerCase().includes(search.toLowerCase());
    }
    if (Array.isArray(obj)) {
      return obj.some((item) => deepSearch(item, search));
    }
    if (typeof obj === 'object') {
      return Object.values(obj).some((value) => deepSearch(value, search));
    }
    return false;
  }

  useEffect(() => {
    let filtered = persist?.issues_findings?.map((item: any, index: number) => ({ ...item, findingId: index })) || [];
    Object.entries(filters).forEach(([key, value]) => {
      if (value) filtered = filtered.filter((f: any) => f[key] === value);
    });
    if (searchValue) {
      filtered = filtered.filter((finding: any) => deepSearch(finding, searchValue));
    }
    setFilteredFindings(filtered);
  }, [persist.issues_findings, filters, searchValue]);

  async function handleDownload_xlsx() {
    // Prepare the data for the Excel sheet
    const worksheetData = filteredFindings?.map((finding) => ({
      'Finding ID': finding.findingId,
      Category: finding.category,
      Severity: finding.severity,
      Confidence: finding.confidence,
      Description: finding.description,
      Location: finding.locationUrl,
      'Date Detected': finding.dateDetected,
      'Affected Assets': finding.affectedAssets,
      'Evidence Type': finding.evidencesType,
      'Evidence Content': finding.evidencesContent,
      Recommendation: finding.recommendation,
      Status: finding.status,
      References: Array.isArray(finding.references) ? finding.references?.join(', ') : finding.references,
      'Remediation Steps': finding.remediationSteps,
      'CWE ID': finding.cweId,
      'CVE ID': finding.cveId,
    }));

    const fileName = 'SecuSeek-Security-Findings';
    exportToExcel({ data: worksheetData, fileName });
  }

  // useEffect(() => {
  //   if (selectedFinding) {
  //     setFilteredFindings(findingsList[selectedFinding]);
  //   }
  // }, [selectedFinding]);

  const Accordion_Contents = (selectedFinding: any): any => {
    const contents: Accordion_Contents_Type[] = [
      {
        title: 'Overview',
        icon: <IconEye />,
        content: (
          <Box>
            {/* <Typography variant="body1">Descriptions</Typography> */}
            {/* <Typography variant="body1">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and
              scrambled it to make a type specimen book. It has survived not only five. Dummy text ever since the 1500s
            </Typography> */}
            <Typography variant="body1">{selectedFinding?.description}</Typography>
          </Box>
        ),
      },
      {
        title: 'Details',
        info_tooltip_text: 'Please review the details of each finding and take action as soon as possible to fix any vulnerabilities.',
        icon: <IconZoomIn />,
        content: (
          <Box>
            <Typography variant="body1" sx={{ mb: 2, fontWeight: 600 }}>
              Detailed Information
            </Typography>
            <Table size="small" sx={{ border: 'none', '& .MuiTableCell-root': { border: 0, px: 1, py: 0.5, fontSize: '14px' } }}>
              <TableBody>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600 }}>Confidence</TableCell>
                  <TableCell>
                    <Stack direction="row" alignContent={'center'} gap={1}>
                      <Chip
                        sx={{
                          borderRadius: '5rem',
                          border: 'none',
                          bgcolor: GetSeverityColor_basic(selectedFinding?.severity as SeverityType, 'dark'),
                          p: '5px',
                          height: '5px',
                          width: '5px',
                          position: 'relative',
                          top: '6px',
                        }}
                      />
                      <Typography variant="body1">{selectedFinding?.confidence}</Typography>
                    </Stack>
                    {/* <Chip
                      label={selectedFinding?.severity}
                      sx={{
                        '& .MuiChip-label': { color: GetSeverityColor_basic(selectedFinding?.severity as SeverityType, 'dark') },
                        bgcolor: GetSeverityColor_basic(selectedFinding?.severity as SeverityType, 'light'),
                        height: 'min-content',
                        py: '2px',
                        mr: 1,
                      }}
                    /> */}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600 }}>Category</TableCell>
                  <TableCell>{selectedFinding?.category || '-'}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600 }}>Location URL</TableCell>
                  <TableCell>{selectedFinding?.locationUrl || '-'}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600 }}>Date Detected</TableCell>
                  <TableCell>
                    {selectedFinding?.dateDetected ? new Date(selectedFinding?.dateDetected)?.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-'}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600 }}>Affected Asset</TableCell>
                  <TableCell>{selectedFinding?.affectedAssets || '-'}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600 }}>Evidence Type</TableCell>
                  <TableCell>{selectedFinding?.evidencesType || '-'}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600 }}>Evidence Content</TableCell>
                  <TableCell>{selectedFinding?.evidencesContent || '-'}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        ),
      },
      {
        title: 'Recommended Action',
        info_tooltip_text: 'Please review the details of each finding and take action as soon as possible to fix any vulnerabilities.',
        icon: <IconSettings />,
        content: (
          <Box>
            <Typography variant="body1">{selectedFinding?.recommendation || '-'}</Typography>
          </Box>
        ),
      },
      {
        title: 'Remediation Steps',
        info_tooltip_text: 'Please review the details of each finding and take action as soon as possible to fix any vulnerabilities.',
        icon: <StarOutlineSharp />,
        content:
          typeof selectedFinding?.remediationSteps === 'string' ? (
            <Typography variant="body1">{selectedFinding?.remediationSteps || '-'}</Typography>
          ) : Array.isArray(selectedFinding?.remediationSteps) ? (
            <List sx={{ pl: 1 }}>
              {selectedFinding?.remediationSteps?.map((step, index) => (
                <ListItem key={index} sx={{ p: 0, display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Typography variant="body2">{index + 1}.</Typography>
                  <Typography variant="body1">{step}</Typography>
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography variant="body1">No remediation steps found</Typography>
          ),
      },
      {
        title: 'References',
        info_tooltip_text: 'Please review the details of each finding and take action as soon as possible to fix any vulnerabilities.',
        icon: <HiOutlineCursorClick />,
        content:
          typeof selectedFinding?.references === 'string' ? (
            <Typography variant="body1">{selectedFinding?.references || '-'}</Typography>
          ) : Array.isArray(selectedFinding?.references) ? (
            <List sx={{ pl: 1 }}>
              {selectedFinding?.references?.map((step, index) => (
                <ListItem key={index} sx={{ p: 0, display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  {/* <Typography variant="body2">•</Typography> */}
                  <Chip
                    color="primary"
                    sx={{
                      borderRadius: '1rem',
                      p: '3px',
                      height: '3px',
                      width: '3px',
                    }}
                  />

                  <Typography variant="body1">{step}</Typography>
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography variant="body1">No references found</Typography>
          ),
      },
    ];
    return contents;
  };

  return (
    <Grid
      sx={{ display: 'flex', alignItems: 'stretch', gap: 2, width: '100%', marginY: 1, paddingTop: 2 }}
      size={12}>
      <Card sx={{ display: 'flex', flexDirection: 'column', gap: '10px', pt: 3 }}>
        {/* ---- Header Row 1 :: Title | Badges | Search Bar | Export Button ---- */}
        <Stack direction={{ xs: 'column', md: 'row' }} alignItems={{ xs: 'stretch', md: 'center' }} justifyContent="space-between" gap={2}>
          <Box>
            <Typography variant="h4" mr={{ xs: 0, md: 2 }} noWrap>
              {persist?.issues_findings?.length} Findings
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%' }}>
            {/* <Typography variant="body1" fontWeight={400}>
              Total:
            </Typography> */}
            <Stack direction="row" gap={3} alignItems={'center'} ml={1}>
              {
                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    gap: 1,
                    width: '100%',
                    maxWidth: '100%',
                  }}
                >
                  {Array.from(new Set(persist?.issues_findings?.map((item) => item.severity).filter(Boolean)))
                    .map((severity) => ({
                      severity,
                      count: persist?.issues_findings?.filter((item) => item.severity === severity)?.length,
                    }))
                    .map((item, idj) => (
                      <Box
                        key={String(item.severity)}
                        sx={{
                          display: 'flex',
                          justifyContent: 'start',
                          alignItems: 'center',
                          rowGap: '4px',
                          columnGap: '4px',
                          maxWidth: '100%',
                          minWidth: 'max-content',
                          flexGrow: 1,
                        }}
                      >
                        {/* {idj !== 0 && <Divider orientation="vertical" flexItem sx={{ height: 24 }} />} */}
                        <Chip
                          label={
                            <Stack direction="row" alignItems={'center'} justifyContent={'center'} gap={`6px`}>
                              <Typography variant="body1" fontWeight={{ xs: 400, md: 800 }}>
                                {String(item.severity)}
                              </Typography>
                              <Typography variant="body1" fontWeight={100}>
                                |
                              </Typography>
                              <Typography variant="body1" fontWeight={800}>
                                {item.count}
                              </Typography>
                            </Stack>
                          }
                          sx={{
                            backgroundColor: `transparent`,
                            minHeight: '8px',
                            height: 'min-content',
                            maxWidth: '100%',
                            '& .MuiChip-label': {
                              backgroundColor: GetSeverityColor_basic(item.severity as SeverityType, 'light'),
                              color: GetSeverityColor_basic(item.severity as SeverityType, 'dark'),
                              // borderColor: GetSev`erityColor_basic(item.severity as SeverityType, 'dark'),
                              // border: 1,
                              minWidth: 20,
                              fontSize: 12,
                              px: 3,
                              py: '2px',
                              // minHeight: '14px',
                              height: 'min-content',
                              borderRadius: '8px',
                              whiteSpace: 'nowrap',
                            },
                          }}
                        />
                      </Box>
                    ))}
                </Box>
              }
            </Stack>
          </Box>
          <Stack direction="row" gap={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <TextField
              placeholder="Search findings"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              InputProps={{
                endAdornment: (
                  <>
                    {searchValue && (
                      <InputAdornment position="end">
                        <IconButton
                          color="primary"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSearchValue('');
                          }}
                          aria-label="clear search"
                        >
                          <IconX size={18} />
                        </IconButton>
                      </InputAdornment>
                    )}
                    <InputAdornment position="end">
                      <Search sx={{ color: 'text.secondary', fontSize: '16px', opacity: 0.5 }} />
                    </InputAdornment>
                  </>
                ),
              }}
              variant="outlined"
              size="small"
              sx={{ width: { xs: '80%', md: '200px' }, bgcolor: (theme) => (searchValue ? theme.palette.action.selected : theme.palette.background.paper) }}
            />
            <Button variant="contained" color="primary" sx={{ minWidth: 0, py: '5px', px: '10px' }} onClick={() => handleDownload_xlsx()}>
              <TbFileExport size={22} style={{ marginRight: 5, minWidth: 20 }} /> Export
            </Button>
          </Stack>
        </Stack>
        {/* Header Row 2 :: Filtering Dropdowns - TODO */}
        <Box
          sx={{
            width: '100%',
            position: 'relative',
            zIndex: 1,
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: { xs: 'end', md: 'space-between' },
            alignItems: { xs: 'end', md: 'center' },
            pr: { xs: 0, md: 2 },
          }}
        >
          <Stack direction="row" gap={1} alignItems={'center'} justifyContent="flex-start" flexWrap="wrap">
            <IconFilter size={20} style={{ marginTop: 4, opacity: 0.7 }} />
            {filterFields.map(({ key, label }) => {
              const options = Array.from(new Set(persist?.issues_findings?.map((f: any) => f[key]).filter(Boolean)));
              return (
                <Box sx={{ position: 'relative', display: 'inline-block' }}>
                  <TextField
                    key={key}
                    select
                    label={label}
                    value={filters[key] || ''}
                    onChange={(e) => setFilters((prev: any) => ({ ...prev, [key]: e.target.value }))}
                    size="small"
                    variant="filled"
                    className={filters[key] ? 'has-value' : ''}
                    sx={{
                      '& .MuiInputBase-input': { bgcolor: 'background.paper' },
                      ...(filters[key] ? { '& .MuiInputBase-input': { bgcolor: undefined } } : {}),
                      minWidth: 120,
                      '&.has-value .MuiInputLabel-root': {
                        color: 'primary.main',
                      },
                      '&.has-value .MuiInputLabel-root.Mui-focused': {
                        color: 'info.main',
                      },
                    }}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          sx: {
                            '& .MuiMenuItem-root:not(.Mui-selected):hover': {
                              fontWeight: 800,
                            },
                          },
                        },
                      },
                    }}
                    InputProps={{
                      endAdornment: filters[key] ? (
                        <InputAdornment position="end" sx={{ cursor: 'pointer', pr: '25px', pt: '2px' }}>
                          {/* <Tooltip title="Clear"> */}
                          <IconX
                            size={16}
                            style={{ opacity: 0.6 }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setFilters((prev: any) => ({ ...prev, [key]: '' }));
                            }}
                          />
                          {/* </Tooltip>` */}
                        </InputAdornment>
                      ) : null,
                    }}
                  >
                    <MenuItem value="">All</MenuItem>
                    {options.map((option: any) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>
              );
            })}
          </Stack>
          <Stack direction="row" gap={3} alignItems={'end'} justifyContent="flex-start" flexWrap="wrap">
            {filteredFindings?.length === persist?.issues_findings?.length ? (
              ``
            ) : filteredFindings?.length > 0 ? (
              <Stack direction="row" gap={1} alignItems={'end'} justifyContent="flex-start" flexWrap="nowrap">
                <Typography variant="caption" fontWeight={400} color={'info.main'}>
                  Showing filtered results ({filteredFindings?.length} of {persist?.issues_findings?.length} total)
                </Typography>
              </Stack>
            ) : (
              <Stack direction="row" gap={1} alignItems={'end'} justifyContent="flex-start" flexWrap="nowrap">
                <Typography variant="caption" fontWeight={400} color={'info.main'}>
                  No results found
                </Typography>
              </Stack>
            )}
            <Tooltip title="Clear all filters">
              <Button
                variant="outlined"
                color={filters && Object.values(filters)?.length > 0 ? 'error' : 'inherit'}
                sx={{
                  top: { xs: '-16px', md: 'unset' },
                  minWidth: 0,
                  p: '2px',
                  borderRadius: 4,
                  opacity: filters && Object.values(filters)?.length > 0 ? 1 : 0.3,
                  height: 'min-content',
                  '&:hover': {
                    opacity: 1,
                  },
                }}
                onClick={() => {
                  setFilters({});
                  setSearchValue('');
                }}
              >
                <IconX size={18} style={{ marginRight: 0, minWidth: 16 }} />
              </Button>
            </Tooltip>
          </Stack>
        </Box>
        <Divider sx={{ position: 'relative', zIndex: 0, top: '-10px' }} />
        {/* ---- Table Body ---- */}
        <Grid container rowSpacing={2} columnSpacing={1}>
          {/* Left Column :: Issue Cards */}
          <Grid
            size={{
              xs: 12,
              md: 5.9
            }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%', mr: 1 }}>
              {Array.isArray(filteredFindings) && filteredFindings?.length > 0 ? (
                filteredFindings?.map((row, index) => (
                  <Card
                    key={index}
                    onClick={() => {
                      setSelectedFinding((prev) => (prev?.findingId === row?.findingId ? null : row));
                      if (isMobile) setMobileDialogOpen(true);
                    }}
                    elevation={0}
                    sx={{
                      border: 1,
                      borderColor: 'divider',
                      backgroundColor: row?.findingId === selectedFinding?.findingId ? 'secondary.light' : 'background.paper',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 0.5,
                      pt: 1,
                      pb: 1,
                      px: 1.5,
                      position: 'relative',
                      cursor: 'pointer',
                      minHeight: 0,
                    }}
                  >
                    <Chip
                      sx={{
                        '& .MuiChip-label': { fontWeight: 700, fontSize: '12px', px: 1 },
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        borderRadius: 1,
                        border: 0,
                        bgcolor: GetSeverityColor_basic(row?.severity, 'light'),
                        color: GetSeverityColor_basic(row?.severity, 'dark'),
                        height: 22,
                        minHeight: 0,
                      }}
                      label={row?.severity}
                      size="small"
                    />
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5, lineHeight: 1.2, width: 'calc(100% - 65px)' }}>
                      {row?.description}
                    </Typography>
                    <Stack direction="row" gap={1} alignItems="center" justifyContent="space-between" sx={{ mt: 0.5 }}>
                      <Stack direction="row" gap={1} alignItems="center" sx={{ mb: 0.5 }}>
                        <Chip variant="outlined" label={row?.category} size="small" sx={{ borderRadius: 1, borderColor: 'GrayText', color: 'text.secondary', p: 0, height: 20, fontSize: '11px' }} />
                        <Typography variant="caption" color="text.secondary" sx={{ fontSize: '11px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 120 }}>
                          {row?.locationUrl}
                        </Typography>
                      </Stack>
                      <Typography variant="caption" sx={{ color: (theme) => theme.palette.grey[400], fontFamily: 'monospace', fontSize: '11px', mt: 0.5 }}>
                        ID: {row?.findingId}
                      </Typography>
                    </Stack>
                  </Card>
                ))
              ) : (
                // <Box
                //   sx={{
                //     display: 'flex',
                //     justifyContent: { xs: 'center', md: 'start' },
                //     alignItems: { xs: 'center', md: 'center' },
                //     flexDirection: { xs: 'column', md: 'row-reverse' },
                //     gap: 2,
                //     ml: '50px',
                //   }}
                // >
                //   <img
                //     style={{
                //       height: '100%',
                //       maxHeight: '150px',
                //       animation: 'growAndSlide 3s backwards ease-in-out',
                //     }}
                //     src={noIncidentImg}
                //     alt={'No results found'}
                //   />
                // </Box>
                (<Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'center' }, alignItems: { xs: 'center', md: 'center' }, flexDirection: 'column' }}>
                  {/* <Transition in={true} appear> */}
                  <Box sx={{ mt: 4, display: 'flex', justifyContent: { xs: 'center', md: 'center' }, alignItems: { xs: 'center', md: 'center' }, gap: 2 }}>
                    {/* <Typography color="textSecondary" variant="body1" fontWeight="800" sx={{ textAlign: 'center', textTransform: 'capitalize', opacity: 0.85 }}>
                      No results found
                    </Typography> */}
                    <img style={{ height: '100%', maxHeight: '100px', animation: 'growAndSlide 3s backwards ease-in-out' }} src={noIncidentImg}></img>
                  </Box>
                  {/* </Transition>` */}
                </Box>)
              )}
            </Box>
          </Grid>
          <Grid
            sx={{ display: { xs: 'none', md: 'block' } }}
            size={{
              xs: 12,
              md: 0.05
            }}>
            <Divider orientation="vertical" sx={{ height: '100%' }} />
          </Grid>
          {/* Right Column :: Issue Content (hide on mobile) */}
          <Grid
            sx={{ display: { xs: 'none', md: 'block' } }}
            size={{
              xs: 12,
              md: 5.9
            }}>
            {!isMobile && <Right_Column_Content selectedFinding={selectedFinding} Accordion_Contents={Accordion_Contents} />}
          </Grid>
        </Grid>
        {/* Mobile Dialog for Finding Details */}
        {isMobile && (
          <Mobile_Finding_Dialog
            open={mobileDialogOpen}
            onClose={() => {
              setMobileDialogOpen(false);
              setSelectedFinding(null);
            }}
            selectedFinding={selectedFinding}
            Accordion_Contents={Accordion_Contents}
          />
        )}
      </Card>
    </Grid>
  );
};

type SeverityType = 'Critical' | 'High' | 'Medium' | 'Low';
type OutputFormatType = 'bootstrapColor' | 'HexColor';

const GetSeverityColor = (severityName: SeverityType, outputFormat: OutputFormatType): string => {
  const severityColors = {
    Critical: {
      bootstrapColor: 'danger',
      HexColor: '#FF3B30',
      muiColor: 'error',
    },
    High: {
      bootstrapColor: 'danger',
      HexColor: '#F96F6F',
      muiColor: 'error',
    },
    Medium: {
      bootstrapColor: 'warning',
      HexColor: '#ffc107',
      muiColor: 'warning',
    },
    Low: {
      bootstrapColor: 'info',
      HexColor: '#0dcaf0',
      muiColor: 'info',
    },
  };

  return severityColors[severityName][outputFormat];
};

const GetSeverityColor_basic = (severityName: SeverityType, theProp: string): string => {
  const severityColors = {
    Critical: {
      light: '#ff3a3021',
      dark: '#FF3B30',
    },
    High: {
      light: '#f96f6f21',
      dark: '#F96F6F',
    },
    Medium: {
      light: '#ffc10721',
      dark: '#ffc107',
    },
    Information: {
      light: '#154bfa21',
      dark: '#6085ff',
    },
    Low: {
      light: '#0dcaf021',
      dark: '#0dcaf0',
    },
    default: {
      light: '#2b2b2b21',
      dark: '#2b2b2b',
    },
  };

  return severityColors?.[severityName]?.[theProp] || severityColors?.default?.[theProp] || '#dedede';
};

const Right_Column_Content = ({ selectedFinding, Accordion_Contents }: any) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%' }}>
      {selectedFinding ? (
        <Card
          elevation={3}
          sx={{
            border: 0,
            borderColor: 'divider',
            pt: 3,
            height: '100%',
            backgroundColor: (theme) => (theme.palette.mode === 'dark' ? 'rgba(40,40,40,0.45)' : 'rgba(208,208,208,0.35)'),
          }}
        >
          {/* background.default | ButtonShadow | secondary.light | white */}
          <Stack direction="row" gap={2} alignItems={'center'} justifyContent={'space-between'} rowGap={1}>
            <Typography variant="h4" color="text.primary">
              {selectedFinding?.description}
            </Typography>
            <Button variant="outlined" color="primary" sx={{ minWidth: 0, px: '10px' }}>
              Actions <IconChevronDown size={22} style={{ marginLeft: 5 }} />
            </Button>
          </Stack>
          <Stack direction="row" gap={1} alignItems={'center'} justifyContent={'start'} mt={1}>
            <Icon sx={{ color: (theme) => theme.palette.grey[400] }}>
              <WarningAmber fontSize="small" />
            </Icon>
            <Typography variant="body2">SecuSeek severity rating</Typography>
            <Icon sx={{ color: (theme) => theme.palette.grey[400] }}>
              <IconInfoCircle />
            </Icon>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Chip
                sx={{
                  borderRadius: '1rem',
                  bgcolor: GetSeverityColor_basic(selectedFinding?.severity as SeverityType, 'dark'),
                  p: '5px',
                  height: '5px',
                  width: '5px',
                }}
              />
              <Typography variant="body1" fontWeight={500}>
                {selectedFinding?.count} {selectedFinding?.severity}
              </Typography>
            </Box>
          </Stack>
          <Box mt={1}>
            {Accordion_Contents(selectedFinding).map((accordion, index) => (
              <Accordion
                key={index}
                elevation={4}
                defaultExpanded={true}
                sx={{
                  mt: 1,
                  borderTopLeftRadius: '12px',
                  borderTopRightRadius: '12px',
                  '&.MuiAccordion-root:not(.Mui-expanded)': {
                    borderBottom: 2,
                    borderColor: 'divider',
                  },
                  '&.MuiAccordion-root.Mui-expanded .MuiButtonBase-root': {
                    borderBottom: 2,
                    borderColor: '#4AD97C',
                    borderTopLeftRadius: '12px',
                    borderTopRightRadius: '12px',
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<IconChevronDown size={22} />}
                  sx={{
                    bgcolor: 'unset',
                    minHeight: '40px!important',
                    '& .MuiAccordionSummary-content': { my: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
                    '& .MuiAccordionSummary-content.Mui-expanded ': { my: 1 },
                    // '& .MuiButtonBase-root.MuiAccordionSummary-content ': { minHeight: '40px!important' },
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
                    <Icon sx={{ color: 'primary.main' }}>{accordion.icon}</Icon>
                    <Typography variant="h5">{accordion.title}</Typography>
                    {accordion.info_tooltip_text && (
                      <Tooltip title={accordion.info_tooltip_text}>
                        <Box sx={{ opacity: 0.7, color: 'info.main', '&>svg': { marginTop: '5px' } }}>
                          <IconInfoCircle />
                        </Box>
                      </Tooltip>
                    )}
                  </Box>
                </AccordionSummary>
                <AccordionDetails sx={{ bgcolor: 'unset' }}>{accordion.content}</AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Card>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            p: 4,
          }}
        >
          <img src={NoFindingsSelectedImage} alt="No Findings Selected" width="200" height="200" loading="lazy" decoding="async" />
          <Typography variant="h5" color="text.secondary" fontWeight={800}>
            No findings selected
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center">
            Please select a finding from the list on the left. <br />
            Once selected, the details will be displayed here
          </Typography>
        </Box>
      )}
    </Box>
  );
};

const Mobile_Finding_Dialog = ({ open, onClose, selectedFinding, Accordion_Contents }: any) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { m: 0, width: '95%', top: '10px' },
      }}
    >
      {/* MuiDialog-container */}
      {/* <DialogTitle>Finding Details</DialogTitle> */}
      {/* <IconButton onClick={onClose} sx={{ position: 'absolute', top: '0px', right: 0 }} aria-label="close" size="medium" color="primary">
        <IconX size={22} />
      </IconButton> */}
      <Box sx={{ height: '20px', bgcolor: 'background.default', position: 'relative' }}>
        <IconButton onClick={onClose} sx={{ position: 'fixed', top: '4px', right: '4px', bgcolor: 'primary.main', color: 'white' }} aria-label="close" size="medium">
          <IconX size={22} />
        </IconButton>
      </Box>
      {/* <Card elevation={0} sx={{ height: '20px', backgroundColor: 'background.default' }}></Card> */}
      <Right_Column_Content selectedFinding={selectedFinding} Accordion_Contents={Accordion_Contents} />
    </Dialog>
  );
};
